import { useEffect } from "react";
import DataTable from "react-data-table-component";
import { customStyles } from "../../../util/TableStyles";
import { noDataComponent } from "../../../util/DataObject";
import { useSpaceCancel } from "./hooks/useSpaceCancel";
import { FlexGrid, Button, Typography, useThemeProvider, Card, Skeleton } from "@albo-ui/core";
import { ManageAccounts, AttachFile } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { SpaceFeaturesProps } from "./types";

export const MassSpaceCancel = ({ changeAlert, changeLoader }: SpaceFeaturesProps) => {
    const { theme } = useThemeProvider();
    const { list, loading: loadingTable, disabled, disabledAdd, columns, getCatalog, onSelectFile, send } = useSpaceCancel(changeAlert);

    const addFile = () => {
        document.getElementById("file").click();
    };

    useEffect(() => {
        changeLoader(loadingTable);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);
    useEffect(() => {
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const init = async () => {
        await getCatalog("cancel");
        document.getElementById("file").click();
    };

    return (
        <Card padding={4} fullWidth fullHeight alignItems="stretch" flexDirection="column" justifyContent="space-between" style={{ borderColor: theme.colors.manatee, margin: 3 }} >
            <FlexGrid container fullWidth justify="space-between">
                <FlexGrid item>
                    <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem" }}>
                        <ManageAccounts sx={{ marginRight: 1 }} /> Cancelación Masiva de Espacios
                    </Typography>
                </FlexGrid>
                <FlexGrid item>
                    <IconButton onClick={addFile.bind(this, "")} sx={{ paddingTop: "0 !important" }}>
                        <AttachFile titleAccess="Agregar desde csv" />
                        <input id="file" type="file" accept="text/csv" style={{ display: "none" }} onChange={onSelectFile.bind(this)}/>
                    </IconButton>
                </FlexGrid>
            </FlexGrid>

            {list.length > 0 && (
                <FlexGrid item style={{ fontWeight: "bolder", marginBottom: "1rem" }}>
                    <hr /> Lista a Cancelar,{" "}
                    <span style={{ color: "#3743aa", fontStyle: "italic" }}>
                        {list.length} {"espacio(s)"}.
                    </span>{" "}
                    {disabledAdd ? (
                        <span style={{ color: "red", fontStyle: "italic" }}>
                            Límite de usuarios alcanzado. Máximo 50
                        </span>
                    ) : null}
                </FlexGrid>
            )}

            {list.length > 0 && (
                <FlexGrid container spacing={2} style={{ margin: "25px 0" }}>
                    {loadingTable ? 
                        <Skeleton width="100%" height="100px" />
                        : 
                        <DataTable
                            columns={columns}
                            data={list}
                            customStyles={customStyles}
                            noDataComponent={noDataComponent}
                        />
                    }
                </FlexGrid>
            )}

            <FlexGrid style={{ alignSelf: "end", marginTop: "2rem" }}>
                <Button disabled={disabled} size="normal" onClick={send}>
                    Aceptar
                </Button>
            </FlexGrid>
        </Card>
    );
};
